import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";

import { dataToDropDownConverter } from "../../../../../helpers";
import { MultiselectDropdown } from "../../multiselect-dropdown";
import { useStore, useTranslation } from "../../../../../hooks";
import { DropdownOptionValue } from "../../dropdown/models";
import { T } from "../../../../../constants";
import { Dropdown } from "../../dropdown";

interface PartnerFilterProps {
  hasAll?: boolean;
  isMulti?: boolean;
  multiValue?: Array<number>;
  value?: DropdownOptionValue;
  onChange?: (value?: DropdownOptionValue | Array<DropdownOptionValue>) => void;
}

export const PartnerFilter: React.FC<PartnerFilterProps> = observer(({
   value,
   onChange,
   hasAll = true,
   isMulti = false,
   multiValue = [],
}) => {
    const t = useTranslation();
    const { partnerStore } = useStore();

    const { partnersForFilter: { data: partners } } = partnerStore;

    const partnersData = useMemo(() => {
      return dataToDropDownConverter(partners, {
        labelKey: "name",
        valueKey: "id",
      });
    }, [partners]);

    return (
      <>
        {
          isMulti ? (
            <MultiselectDropdown
              withSearch
              value={multiValue}
              data={partnersData}
              label={t(T.PARTNERS)}
              showSelectAll={hasAll}
              onChange={(data) => onChange?.(data as Array<number>)}
            />
          ) : (
            <Dropdown
              value={value}
              hasAll={hasAll}
              onChange={onChange}
              data={partnersData}
              label={t(T.PARTNER)}
              withSearch={!!partnersData.length}
            />
          )
        }

      </>

    );
  },
);
